<div class="bmw-bulletin-container">
  <div class="bmw-message-title">
    {{ messageId ? 'Edit Message' : 'Add Message' }}
  </div>
  <div class="bmw-bulletin-info">
    <div class="bmw-heading">Sites</div>
    <div class="flex-container">
      <div class="check-box-container flex-25" *ngIf="isAdmin">
        <label class="">BMW
          <input type="radio" name="msgbrand" value="bmw" [(ngModel)]='domain'>
          <span class="checkmark"></span>
        </label>
      </div>
      <div class="check-box-container flex-25" *ngIf="isAdmin">
        <label class="">MINI
          <input type="radio" name="msgbrand" value="mini" [(ngModel)]='domain'>
          <span class="checkmark"></span>
        </label>
      </div>
      <div class="check-box-container flex-25" *ngIf="isAdmin || isMotorradAdmin">
        <label class="">MOTORRAD
          <input type="radio" name="msgbrand" value="motorrad" [(ngModel)]='domain'>
          <span class="checkmark"></span>
        </label>
      </div>
      <div class="check-box-container flex-25" *ngIf="isAdmin || isRollsRoyceAdmin">
        <label class="">ROLLSROYCE
          <input type="radio" name="msgbrand" value="rollsroyce" [(ngModel)]='domain'>
          <span class="checkmark"></span>
        </label>
      </div>
    </div>
    <div class="bmw-heading" style="margin-top:20px">Location</div>
    <div class="flex-container">
      <div class="check-box-container flex-25">
        <label>Home Page
          <input type="radio" name="mininet" value="Home" [(ngModel)]='location'>
          <span class="checkmark"></span>
        </label>
      </div>
      <div class="check-box-container flex-25">
        <label>Login Page
          <input type="radio" name="mininet" value="Login" [(ngModel)]='location'>
          <span class="checkmark"></span>
        </label>
      </div>
    </div>
    <div class="bmw-heading" style="margin-top: 25px">Message</div>
    <div>
      <textarea [(ngModel)]='messageContent' placeholder="Enter Message" maxlength="500"></textarea>
    </div>
    <small style="color: red">{{errorMessage}}</small>
    <div class="bmw-submit-button justify-center-align-center">
      <button class="bmw-button-secondary" [disabled]='!domain || !messageContent || !location'
        (click)='submitMessage()'>SUBMIT</button>
    </div>
  </div>
</div>